import { styled, keyframes } from "styled-components";

interface AnalyticsBarContainerProps {
    $width: number;
    $height: number;
}

interface BoundProps {
    $width: number;
}

interface OuterBarProps {
    $width: number;
}

interface InnerBarProps {
    $width: number;
    $animationTime: number;
}

interface ValueLabelAndBarProps {
    $finalWidth: number;
    $animationTime: number;
}

interface VerticalBarProps {
    $finalWidth: number;
    $animationTime: number;
    $barLine: boolean;
}

export const InnerBarKeyframes = (props: number) => keyframes`
    0% {
            width: 0%;
        }
    100% {
        width: ${props}%;
    }
`;

export const LabelAndBarKeyframes = (final: number) => keyframes`
    0%{
        left:0
    }100%{
        left: ${final}%
    }
`;

export const AnalyticsBarContainer = styled.div<AnalyticsBarContainerProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: ${(props) => props.$width}%;
    height: ${(props) => props.$height}%;
`;

export const BarAndLabelContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
`;

export const BarValueLabel = styled.div<ValueLabelAndBarProps>`
    font-weight: 600;
    padding-left: 1rem;
    position: absolute;
    animation: ${(props) => LabelAndBarKeyframes(props.$finalWidth)}
        ${(props) => props.$animationTime}s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    top: 0;
`;

export const BarLine = styled.div<VerticalBarProps>`
    display: ${props=>props.$barLine? 'block':'none'};
    height: 40%;
    border: 1px solid black;
    border-radius: 10px;
    position: absolute;
    animation: ${(props) => LabelAndBarKeyframes(props.$finalWidth)}
        ${(props) => props.$animationTime}s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
`;

export const OuterBar = styled.div<OuterBarProps>`
    transition: ${props=>props.theme.animationTime.short}s all ease;
    width: ${(props) => props.$width}px;
    height: 10%;
    border-radius: 5px;
`;

export const InnerBar = styled.div<InnerBarProps>`
    background: ${props=>props.theme.gradient.default};
    height: 100%;
    animation: ${(props) => InnerBarKeyframes(props.$width)}
        ${(props) => props.$animationTime}s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    border-radius: 5px 0 0 5px;
`;

export const BoundText = styled.div<BoundProps>`
    text-align: center;
    width: ${(props) => props.$width}px;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    font-weight: 550;
`;

export const BarLabel = styled.div<BoundProps>`
    width: ${(props) => props.$width}px;
    text-align: left;
    font-weight: 600;
    text-transform: uppercase;

`;